// Shared by Add and Import, including Fix and the submitted payload.
export const EXTERNAL_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export const normalizeExternalId = (value) =>
  String(value ?? "")
    .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, "-")
    .replace(/[\u200B-\u200D\u2060\uFEFF]/g, "")
    .trim();

export const getExternalIdError = (value) => {
  const id = normalizeExternalId(value);
  if (!id) return "external_id_missing";
  const hasSpace = /\s/.test(id);
  const hasOther = /[^A-Za-z0-9\-\s]/.test(id);
  if (hasSpace && hasOther) return "external_id_mixed";
  if (hasSpace) return "external_id_space";
  if (hasOther) return "external_id_characters";
  return null;
};

export const isValidExternalId = (value) =>
  EXTERNAL_ID_PATTERN.test(normalizeExternalId(value));
